import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/new_auction/account_management",
  component: function component() {
    return import("../../../views/new_auction/account_management.vue");
  },
  name: "account_management",
  meta: {
    foot: true,
    title: "账户管理"
  }
}, {
  path: "/new_auction_recharge",
  component: function component() {
    return import("../../../views/new_auction/new_auction_recharge.vue");
  },
  name: "new_auction_recharge",
  meta: {
    foot: true,
    title: "充值"
  }
}, {
  path: "/new_auction_billing",
  component: function component() {
    return import("../../../views/new_auction/new_auction_billing.vue");
  },
  name: "new_auction_billing",
  meta: {
    foot: true,
    title: "账单明细"
  }
}, {
  path: "/new_auction_rechargeDetail",
  component: function component() {
    return import("../../../views/new_auction/new_auction_billing.vue");
  },
  name: "new_auction_rechargeDetail",
  meta: {
    foot: true,
    title: "充值明细"
  }
}, {
  path: "/new_auction_rechargeRecord",
  component: function component() {
    return import("../../../views/new_auction/new_auction_rechargeRecord.vue");
  },
  name: "new_auction_rechargeRecord",
  meta: {
    foot: true,
    title: "充值详情"
  }
}, {
  path: "/new_auction_Income_detail",
  component: function component() {
    return import("../../../views/new_auction/new_auction_Income_detail.vue");
  },
  name: "new_auction_Income_detail",
  meta: {
    foot: true,
    title: "收益详情"
  }
}, {
  path: "/new_auction_Profit_detail",
  component: function component() {
    return import("../../../views/new_auction/new_auction_Income_detail.vue");
  },
  name: "new_auction_Profit_detail",
  meta: {
    foot: true,
    title: "盈利明细"
  }
}, {
  path: "/new_auction_supplier",
  component: function component() {
    return import("../../../views/new_auction/new_auction_Income_detail.vue");
  },
  name: "new_auction_supplier",
  meta: {
    foot: true,
    title: "拍卖供应商奖励"
  }
}, {
  path: "/new_auction_Bidding_detail",
  component: function component() {
    return import("../../../views/new_auction/new_auction_Bidding_detail.vue");
  },
  name: "new_auction_Bidding_detail",
  meta: {
    foot: true,
    title: "参拍明细"
  }
}, {
  path: "/new_auction_Auction_details",
  component: function component() {
    return import("../../../views/new_auction/new_auction_Bidding_detail.vue");
  },
  name: "new_auction_Auction_details",
  meta: {
    foot: true,
    title: "委拍明细"
  }
}, {
  path: "/new_auction_withdraw/:tag?",
  component: function component() {
    return import("../../../views/new_auction/new_auction_withdraw.vue");
  },
  name: "new_auction_withdraw",
  meta: {
    foot: true,
    title: "提现"
  }
}, {
  path: "/new_auction_index",
  component: function component() {
    return import("../../../views/new_auction/index.vue");
  },
  name: "new_auction_index",
  meta: {
    foot: false,
    title: "拍品列表"
  }
}, {
  path: "/new_auction_detail/:id?",
  component: function component() {
    return import("../../../views/new_auction/new_auction_detail.vue");
  },
  name: "new_auction_detail",
  meta: {
    foot: true,
    title: "拍品详情"
  }
}, {
  path: "/new_auction_order/:new_auction_id/:new_auction_pick_num",
  component: function component() {
    return import("../../../views/goods/goods_order.vue");
  },
  name: "new_auction_order",
  meta: {
    foot: true,
    title: "商品订单详情"
  }
}, {
  path: "/serviceManagement",
  component: function component() {
    return import("../../../views/new_auction/serviceManagement.vue");
  },
  name: "serviceManagement",
  meta: {
    foot: true,
    title: "服务管理"
  }
}, {
  path: "/serviceManagement_index",
  component: function component() {
    return import("../../../views/new_auction/serviceManagement_index.vue");
  },
  name: "serviceManagement_index",
  meta: {
    foot: true,
    title: "服务管理"
  }
}, {
  path: "/new_auction/profit_detail",
  component: function component() {
    return import("../../../views/new_auction/profit_detail.vue");
  },
  name: "new_auction_profit_detail",
  meta: {
    foot: true,
    title: "收益/盈利"
  }
}, {
  path: "/new_auction/auction_bidding_details",
  component: function component() {
    return import("../../../views/new_auction/auction_bidding_details.vue");
  },
  name: "auction_bidding_details",
  meta: {
    foot: true,
    title: "参拍/委拍明细"
  }
}, {
  path: "/new_auction/Pending_goods",
  component: function component() {
    return import("../../../views/new_auction/Pending_goods.vue");
  },
  name: "new_auction_Pending_goods",
  meta: {
    foot: true,
    title: "待提商品"
  }
}, {
  path: "/new_auction/Warehouse",
  component: function component() {
    return import("../../../views/new_auction/new_auction_Warehouse.vue");
  },
  name: "new_auction_Warehouse",
  meta: {
    foot: true,
    title: "我的仓库"
  }
}, {
  path: "/new_auction/wallet",
  component: function component() {
    return import("../../../views/new_auction/wallet.vue");
  },
  name: "new_auction_wallet",
  meta: {
    foot: true,
    title: "钱包"
  }
}, {
  path: "/new_auction/instructions",
  component: function component() {
    return import("../../../views/new_auction/instructions.vue");
  },
  name: "new_auction_instructions",
  meta: {
    foot: true,
    title: "拍卖须知"
  }
}];